import { styled as t } from "styled-components";
import { FloatingElementHorizontalPosition as i, FloatingElementVerticalPosition as o } from "./consts.js";
const n = 8, a = 8, p = t.div`
  display: block;
`, r = t.div`
  position: absolute;

  width: var(--width);
  height: var(--height);
  top: var(--top);
  left: var(--left);

  opacity: var(--opacity, 0);
  z-index: 1;
`, s = t.div`
  position: relative;
  display: flex;
  height: inherit;

  &[data-horizontal-position='${i.MIDDLE}'] {
    justify-content: center;
  }
`, d = t.div`
  visibility: visible;
  position: absolute;

  width: max-content;

  &[aria-hidden='true'] {
    visibility: hidden;
  }

  &[data-horizontal-position='${i.RIGHT}'] {
    left: -10px;
  }

  &[data-horizontal-position='${i.LEFT}'] {
    right: -10px;
  }

  &[data-vertical-position='${o.TOP}'] {
    bottom: calc(100% + ${n}px + ${a}px);
  }

  &[data-vertical-position='${o.BOTTOM}'] {
    top: calc(100% + ${n}px + ${a}px);
  }
`;
export {
  r as ChildClone,
  s as ContentWrapper,
  d as FloatingElement,
  p as FloatingElementContainer
};
